<div class="container-products">
    <p-toast />
    <div *ngIf="!showPayment" class="accordion accordion-flush" id="accordionOrderList">
        <div class="accordion-item" *ngFor="let order of orderList, let ix = index">
            <h2 class="accordion-header">
                <button type="button" class="accordion-button collapsed d-flex flex-column" data-bs-toggle="collapse" [attr.data-bs-target]="'#flush-collapse-'+ix" aria-expanded="false" [attr.aria-controls]="'flush-collapse-'+ix">
                    <div class="order-info-detail">
                        <div class="">
                            <div class="">
                                <span>Orden N°: {{order.order_id}}</span>
                            </div>
                            <!-- <div class="">
                                <span>Ciente: {{order.userName}}</span>
                            </div>
                            <div class="">
                                <span>C.P.: {{order.cp}}</span>
                            </div> -->
                            <div class="">
                                <span>Proceso: {{order.status}}</span>
                            </div>
                        </div>
                        <div class="">
                            <span>Fecha Actualización: {{order.activacion | date:'dd-MM-YYYY'}}</span>
                        </div>
                    </div>
                </button>
            </h2>
            <div *ngIf="order.status == 'Esperando Confirmación'" class="mt-3 mb-2 d-flex w-100 flex-column">
                <div class="col-12 my-4 text-center">
                    <span>La cotización ha sido enviada a su correo.</span>
                </div>
                <div class="d-flex w-100 justify-content-around">
                    <button type="button" class="btn btn-info" (click)="continueOrder('Cotización Aceptada', order.order_id)">Aceptar Cotización</button>
                    <button type="button" class="btn btn-light" (click)="continueOrder('Rechazada', order.order_id)">Rechazar Cotización</button>
                </div>
            </div>
            @if ( order.status == 'Cotización Aceptada' && !order.status_payment ) {
                <div class="mt-3 mb-2 d-flex flex-column flex-md-row gap-3 align-items-start justify-content-around">
                    <!-- <app-order-image-upload [orderId]="order.order_id"></app-order-image-upload> -->
                    <!-- <app-btn-wallet [idPayment]="paymentId"></app-btn-wallet> -->
                    <button type="button" class="btn btn-info" (click)="generatePayment(ix)">Realizar Pago</button>
                </div>
            }
            @if ( order.status_payment ) {
                @switch (order.status_payment) {
                    @case ('in_process') {
                        <div class="mt-3 mb-2 d-flex w-100 justify-content-around">
                            <div class="my-4 text-center">
                                <span>Pago en proceso...</span><br>
                                <span>Se está procesando su pago</span>
                            </div>
                            <div>
                                <button type="button" class="btn btn-info my-4" (click)="validarPago(order.paymentId)">Validar Pago</button>
                            </div>
                        </div>
                    }
                    @case ('pending') {
                        <div class="mt-3 mb-2 d-flex w-100 justify-content-around">
                            <div class="my-4 text-center">
                                <span>Pago pendiente</span><br>
                                <span>Se está procesando su pago</span>
                            </div>
                            <div>
                                <button type="button" class="btn btn-info my-4" (click)="validarPago(order.paymentId)">Validar Pago</button>
                            </div>
                        </div>
                    }
                    @case ('rejected') {
                        <div class="mt-3 mb-2 d-flex w-100 justify-content-around">
                            <div class="my-4 text-center">
                                <span>Pago rechazado</span><br>
                                <span>El pago no fue aprobado</span>
                            </div>
                            <div>
                                <button type="button" class="btn btn-info my-4" (click)="generatePayment(ix)">Reintentar Pago</button>
                            </div>
                        </div>
                    }
                    @case ('approved') {
                        <div class="mt-3 mb-2 d-flex w-100 justify-content-around">
                            <div class="my-4 text-center">
                                <span>Pago aprobado</span><br>
                                <span>Su pedido se está procesando</span>
                            </div>
                        </div>
                    }
                }
            }
            <div [id]="'flush-collapse-'+ix" class="accordion-collapse collapse" 
                data-bs-parent="#accordionOrderList"
                >
                <div class="accordion-body">
                    <ul  *ngFor="let detail of order?.details">
                        <li>
                            <span>{{detail.product}}
                                <span class="ml-2">({{detail.quantity}})</span> 
                            </span>
                        </li>
                    </ul>
                    <!-- <div class="row g-4">
                        <span>
                            Producto: {{detail.product}} <span class="ml-2">({{detail.quantity}})</span> 
                        </span>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showPayment" class="text-center my-5">
        <div class="text-start accordion-body">
            <div class="d-flex justify-content-between">
                <h4 class="accordion-header px-3 py-2">
                    Detalle de la Orden: {{orderInfo}}
                </h4>
                <h4 class="accordion-header px-3 py-2">
                    Total: {{totalAmount | currency}}
                </h4>
            </div>
            <ul  *ngFor="let detail of paymentList">
                <li>
                    <span>{{detail?.title || ''}}
                        <span class="ml-2">({{detail?.quantity || ''}})</span> 
                    </span>
                </li>
            </ul>
            <!-- <div class="row g-4">
                <span>
                    Producto: {{detail.product}} <span class="ml-2">({{detail.quantity}})</span> 
                </span>
            </div> -->
        </div>
        <div *ngIf="showPayment22">
            <div *ngIf="paymentId" class="d-flex justify-content-center">
                <app-btn-wallet  [idPayment]="paymentId"></app-btn-wallet>
            </div>
            <button class="btn btn-primary mt-3" (click)="cancelPayment()">Regresar a Mis Ordenes</button>
        </div>
    </div>

</div>